import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Columns must have the same names as the original CSV file."),
  /*#__PURE__*/_createElementVNode("li", null, "New columns can be added.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_message = _resolveComponent("b-message")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_csv_upload_form = _resolveComponent("csv-upload-form")!
  const _component_side_pane = _resolveComponent("side-pane")!

  return (_openBlock(), _createBlock(_component_side_pane, {
    title: _ctx.operation.title,
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_b_message, {
            key: 0,
            type: "is-danger"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.error), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_o_field, null, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _createTextVNode(" You can upload a new CSV file to replace "),
            _createElementVNode("em", null, _toDisplayString(_ctx.source.name), 1),
            _createTextVNode(". ")
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_b_message, { type: "is-info" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_csv_upload_form, {
        "allow-multiple": false,
        "file-meta": _ctx.fileMeta,
        "is-loading": _ctx.isLoading,
        source: _ctx.source,
        onSubmit: _ctx.submit,
        onClose: _ctx.close
      }, null, 8, ["file-meta", "is-loading", "source", "onSubmit", "onClose"])
    ]),
    _: 1
  }, 8, ["title", "onClose"]))
}